import React from "react";

const Like = ({ liked, onClick }) => {
  let classes = "fa-heart ";
  liked ? (classes += "fa-solid") : (classes += "fa-regular");
  return (
    <i style={{ cursor: "pointer" }} className={classes} onClick={onClick}></i>
  );
};

export default Like;
